var StoreAvailabilityProbabilityEnum;
(function (StoreAvailabilityProbabilityEnum) {
    StoreAvailabilityProbabilityEnum["highInStock"] = "HIGH_IN_STOCK";
    StoreAvailabilityProbabilityEnum["mediumInStock"] = "MEDIUM_IN_STOCK";
    StoreAvailabilityProbabilityEnum["lowInStock"] = "LOW_IN_STOCK";
    StoreAvailabilityProbabilityEnum["someLowOrOutOfStock"] = "SOME_LOW_OR_OUT_OF_STOCK";
    StoreAvailabilityProbabilityEnum["outOfStock"] = "OUT_OF_STOCK";
    StoreAvailabilityProbabilityEnum["notSoldAtStore"] = "NOT_SOLD_AT_STORE";
    /** Single product - will show caption text for StoreSelector. */
    StoreAvailabilityProbabilityEnum["orderItemSingle"] = "ORDER_ITEM_SINGLE";
    /** Multipe products - caption text for StoreSelector should be hidden. */
    StoreAvailabilityProbabilityEnum["orderItemMultiple"] = "ORDER_ITEM_MULTIPLE";
})(StoreAvailabilityProbabilityEnum || (StoreAvailabilityProbabilityEnum = {}));
export default StoreAvailabilityProbabilityEnum;
//# sourceMappingURL=StoreAvailabilityProbabilityEnum.js.map